/**
 * Paragraph component
 *
 * Optional props:
 * inline : boolean - display inline
 * block : boolean - display block
 * primary : boolean - primary text color
 * light : boolean - light text color
 * bold : boolean - bold font weight
 *
 * Example of components:
 * <Label>Standard label</Label>
 * <Label htmlFor="nameOfInput" primary>Label with primary style</Label>
 *
 */

import styled from 'styled-components';
import { colors } from '../../variables';

const getFontColor = props => {
	if (props.primary) return colors.blue.bromma;
	if (props.light) return '#fff';
	return colors.grey.graphite;
};

const getDisplay = props => {
	if (props.inline) return 'inline';
	if (props.block) return 'block';
	return 'inline-block';
};

export default styled.label`
	cursor: pointer;
	display: ${props => getDisplay(props)};
	color: ${props => getFontColor(props)};
	font-weight: ${props => (props.bold ? 'bold' : 'unset')};
`;



// WEBPACK FOOTER //
// ./src/components/Common/Label/Label.js